import styles from "./Main.module.scss";
import showMenu  from "../../assets/img/logo_om.avif";
export const Main = () => {
  return (
    <div className={styles.container}>
      <img
        style={{
          marginLeft: "auto",
          maxHeight: 720,
          width: "100%",
          objectFit: "contain",
        }}
        src={showMenu}></img>
    </div>
  );
};
